// @ts-expect-error Could not find a declaration file
import Client from 'AdsUI/data/Client'; // @ts-expect-error Could not find a declaration file

import { EntityTypes } from 'AdsUI/lib/Constants';
import { getListsClientEndpointPath } from 'AdsUI/lib/ContactList';
const WORKFLOWS_BASE = 'ads/v1/workflows'; // Even though these are in the path, they need to be in all caps

const ENTITY_TYPE_ROUTE_MAP = {
  [EntityTypes.CAMPAIGN]: 'CAMPAIGN',
  [EntityTypes.ADGROUP]: 'ADGROUP',
  [EntityTypes.AD]: 'AD',
  [EntityTypes.KEYWORD]: 'KEYWORD'
};

const getPathForEntityType = ({
  entityType,
  network,
  accountId,
  campaignId,
  adGroupId,
  adId,
  keywordId
}) => {
  const baseUrl = `${network.toLowerCase()}/account/${accountId}/campaign/${campaignId}`;

  switch (entityType) {
    case EntityTypes.CAMPAIGN:
      return baseUrl;

    case EntityTypes.ADGROUP:
      return `${baseUrl}/adgroup/${adGroupId}`;

    case EntityTypes.AD:
      return `${baseUrl}/adgroup/${adGroupId}/ad/${adId}`;

    case EntityTypes.KEYWORD:
      return `${baseUrl}/adgroup/${adGroupId}/keyword/${keywordId}`;

    default:
      throw new Error(`Unknown entity type ${entityType}`);
  }
};

export const createWorkflow = ({
  entityType,
  network,
  accountId,
  campaignId,
  adGroupId,
  adId,
  keywordId,
  leadSyncingEntityId,
  formId
}, name) => Client.apiRequest(`${WORKFLOWS_BASE}/${getPathForEntityType({
  entityType,
  network,
  accountId,
  campaignId,
  adGroupId,
  adId,
  keywordId
})}`, {
  type: 'POST',
  query: {
    name,
    pageId: leadSyncingEntityId,
    formId
  }
});
export const createList = ({
  entityType,
  network,
  accountId,
  campaignId,
  adGroupId,
  adId,
  keywordId
}, name, hasListsClientMigrationGate) => Client.apiRequest(`ads/v1/${getListsClientEndpointPath(hasListsClientMigrationGate)}/${getPathForEntityType({
  entityType,
  network,
  accountId,
  campaignId,
  adGroupId,
  adId,
  keywordId
})}/active-list`, {
  type: 'POST',
  query: {
    name
  }
});
export const createWorkflowWithoutEnrollmentCriteria = (name, isSimpleWorkflow = false) => Client.apiRequest(`${WORKFLOWS_BASE}/workflow`, {
  type: 'POST',
  query: {
    name,
    isSimpleWorkflow
  }
});
export const getWorkflowForEntity = (network, adAccountId, entityType, entityId) => Client.apiRequest(`${WORKFLOWS_BASE}/${network.toLowerCase()}/account/${adAccountId}/${ENTITY_TYPE_ROUTE_MAP[entityType]}/${entityId}`);
export const getAllWorkflowsForEntity = ({
  network,
  adAccountId,
  entityType,
  entityIds
}) => {
  return Client.apiRequest(`ads/v1/workflows/${network}/account/${adAccountId}/${entityType}?`, {
    query: {
      entityIds
    }
  });
};